import { Box, Flex, Text, VStack, useColorModeValue } from "@chakra-ui/react";
import "@fontsource/comic-mono/latin-400.css";
import "@fontsource/courier-prime/index.css";
import "@fontsource/courier-prime/latin-700-italic.css";
import { GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import Layout from "../../containers/Layout";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { UserContext } from "../../contexts/UserContext";
import BoxInfoTemplate from "../BoxInfoTEmplate/BoxInfoTemplate";
import { motion } from "framer-motion";
import Seo from "../Seo/Seo";

const MotionBox = motion(Box);

const Login = () => {
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();

  const postData = async (data) => {
    try {
      const response = await axios.post("/api/login", data);
      const decoded = jwtDecode(response.data);
      setUser(decoded);
      navigate("/");
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Layout pt="120">
      <Seo title="Log In" path="/login" noIndex />
      {/* Encabezado estilo cómic más suave y amigable */}
      <BoxInfoTemplate
        iconType="redDot" // ícono simple y neutro
        mainText="Unlock ALL the content. It’s free, easy, and made for you!"
        showQuotes={false} // 🔄 SIN bocadillo rojo
        borderColor="blue.100" // 🎨 Borde más amable
      />

      {/* Área de login con animación suave */}
      <Flex direction="column" align="center" mt={10} px={4}>
        <MotionBox
          p={8}
          borderRadius="xl"
          boxShadow="lg"
          bg={useColorModeValue("gray.50", "gray.700")}
          textAlign="center"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <VStack spacing={6}>
            <Text fontFamily="Courier Prime" fontSize="lg">
              Log in with Google to get access to all content.
            </Text>

            <Box
              borderRadius="md"
              overflow="hidden"
              width="fit-content"
              mx="auto"
              p="2px" // <--- Añade esto
            >
              <GoogleLogin
                onSuccess={(credentialResponse) => {
                  const decoded = jwtDecode(credentialResponse?.credential);
                  const { email, name, picture } = decoded;
                  postData({ email, name, picture });
                }}
                onError={() => {
                  console.log("Login Failed");
                }}
              />
            </Box>

            <Text fontSize="sm" color="gray.500" fontFamily="Comic Mono">
              And your data is extra safe with me. 🌱
            </Text>
          </VStack>
        </MotionBox>
      </Flex>
    </Layout>
  );
};

export default Login;
